import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const ChevronRightLeft = ({
  fill = '#1E293B',
  height = 34,
  width = 34,
  style = {}
}: React.SVGProps<SVGSVGElement>) => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 34 34"
      fill="none"
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0973 7.77773C22.6342 8.3147 22.6342 9.1853 22.0973 9.72227L14.8195 17L22.0973 24.2777C22.6342 24.8147 22.6342 25.6853 22.0973 26.2223C21.5603 26.7592 20.6897 26.7592 20.1527 26.2223L11.9027 17.9723C11.3658 17.4353 11.3658 16.5647 11.9027 16.0277L20.1527 7.77773C20.6897 7.24076 21.5603 7.24076 22.0973 7.77773Z"
        fill={fill}
      />
    </svg>
  </SVGUniqueID>
);

export { ChevronRightLeft };
